import { render, staticRenderFns } from "./AddressCompositionBuilder.vue?vue&type=template&id=5d522d4a&scoped=true"
import script from "./AddressCompositionBuilder.vue?vue&type=script&lang=js"
export * from "./AddressCompositionBuilder.vue?vue&type=script&lang=js"
import style0 from "./AddressCompositionBuilder.vue?vue&type=style&index=0&id=5d522d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d522d4a",
  null
  
)

export default component.exports